export enum FloorplanMeasurementArrowheadStyle {
  Oblique = 'oblique',
  OpenArrow = 'open-arrow',
}
